import { inject, Injectable } from '@angular/core';
import { PaymentMode, SelectedPaymentMode } from '@checkout-v2/const';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CheckoutActions } from '../store/actions/';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class PaymentModesFacade {
  private readonly store = inject(Store<StateWithCustomCheckout>);

  getListState(): Observable<StateUtils.LoaderState<PaymentMode[]>> {
    return this.store.pipe(select(CheckoutSelectors.paymentModesListState));
  }

  getList(): Observable<PaymentMode[]> {
    return this.store.pipe(select(CheckoutSelectors.paymentModesListValue));
  }

  getListLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.paymentModesListLoading));
  }

  getListError(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.paymentModesListError));
  }

  getListSuccess(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.paymentModesListSuccess));
  }

  initCardBindingOnExternalAddress(): void {
    this.store.dispatch(new CheckoutActions.InitCardBinding());
  }

  setActivePaymentMode(paymentMode: SelectedPaymentMode | undefined): void {
    this.store.dispatch(new CheckoutActions.SetActivePaymentMode({ paymentMode }));
  }

  getActivePaymentMode(): Observable<SelectedPaymentMode | undefined> {
    return this.store.pipe(select(CheckoutSelectors.activePaymentModeValue));
  }

  getActivePaymentModeError(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.activePaymentModeError));
  }
}
